import { ENABLE_MOBILE_SIGNUP_HANDOFF } from "config/featureFlags";
import { classifyRuntimeDevice } from "./signupDevice";

export const MOBILE_SIGNUP_HANDOFF_EXPERIENCE_VERSION = "mobile_signup_handoff_v1";
export const MOBILE_SIGNUP_HANDOFF_PATH = "/mobile-signup-handoff";
export const CONTINUE_SETUP_PATH = "/continue-setup";
export const CONTINUE_SETUP_RETURN_STORAGE_KEY = "llp_continue_setup_return_path";
export const MOBILE_SIGNUP_HANDOFF_SESSION_DISMISSED_KEY = "llp_mobile_signup_handoff_session_dismissed";

export function getRuntimeSignupDeviceClassification(options = {}) {
  return classifyRuntimeDevice(options);
}

export function shouldRouteToMobileSignupHandoff(options = {}) {
  if (!ENABLE_MOBILE_SIGNUP_HANDOFF) {
    return false;
  }

  return getRuntimeSignupDeviceClassification(options).isRotateGateCandidate;
}

export function getMobileSignupRedirectPath(options = {}) {
  return shouldRouteToMobileSignupHandoff(options) ? MOBILE_SIGNUP_HANDOFF_PATH : "/";
}

export function markMobileSignupHandoffSessionDismissed() {
  try {
    sessionStorage.setItem(MOBILE_SIGNUP_HANDOFF_SESSION_DISMISSED_KEY, "true");
  } catch (error) {
    // Ignore private-mode storage failures.
  }
}

export function shouldUseMobileSignupHandoffSessionDismissed() {
  try {
    return sessionStorage.getItem(MOBILE_SIGNUP_HANDOFF_SESSION_DISMISSED_KEY) === "true";
  } catch (error) {
    return false;
  }
}

export function saveContinueSetupReturnPath(path = "/") {
  try {
    sessionStorage.setItem(CONTINUE_SETUP_RETURN_STORAGE_KEY, path || "/");
  } catch (error) {
    // Ignore private-mode storage failures.
  }
}

export function consumeContinueSetupReturnPath() {
  try {
    const value = sessionStorage.getItem(CONTINUE_SETUP_RETURN_STORAGE_KEY);
    sessionStorage.removeItem(CONTINUE_SETUP_RETURN_STORAGE_KEY);
    return value || "";
  } catch (error) {
    return "";
  }
}
